import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "actions"];
import { c as _c } from "react-compiler-runtime";
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { Text } from 'foundations-components/components/Text';
import { TABS } from 'collaboration-sidebar/constants/tabs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TabHeader = t0 => {
  "use memo";

  const $ = _c(10);
  let actions;
  let children;
  let props;
  if ($[0] !== t0) {
    var _t = t0;
    ({
      children,
      actions
    } = _t);
    props = _objectWithoutPropertiesLoose(_t, _excluded);
    _t;
    $[0] = t0;
    $[1] = actions;
    $[2] = children;
    $[3] = props;
  } else {
    actions = $[1];
    children = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== children) {
    t1 = /*#__PURE__*/_jsx(Box, {
      flexGrow: 1,
      marginBlockEnd: "0",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "heading-300",
        children: children
      })
    });
    $[4] = children;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== actions || $[7] !== props || $[8] !== t1) {
    t2 = /*#__PURE__*/_jsxs(Flex, Object.assign({
      alignItems: "center",
      paddingBlock: "400",
      paddingInlineStart: "800",
      paddingInlineEnd: "500",
      flexGrow: 0,
      borderBlockEndWidth: "100",
      borderBlockEndStyle: "solid",
      borderBlockEndColor: "border-core-subtle",
      minBlockSize: "64px"
    }, props, {
      children: [t1, actions]
    }));
    $[6] = actions;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default function Tab(t0) {
  "use memo";

  const $ = _c(10);
  const {
    heading,
    actions,
    children,
    showHeader: t1,
    tab
  } = t0;
  const showHeader = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== actions || $[1] !== heading || $[2] !== showHeader || $[3] !== tab) {
    t2 = showHeader && /*#__PURE__*/_jsx(TabHeader, {
      backgroundColor: tab === TABS.COMMENTS ? "fill-surface-default" : undefined,
      actions: actions,
      children: heading
    });
    $[0] = actions;
    $[1] = heading;
    $[2] = showHeader;
    $[3] = tab;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children) {
    t3 = /*#__PURE__*/_jsx(Box, {
      grow: 1,
      minBlockSize: "0%",
      overflowY: "auto",
      position: "relative",
      children: children
    });
    $[5] = children;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = /*#__PURE__*/_jsxs(Flex, {
      blockSize: "100%",
      flexDirection: "column",
      alignItems: "stretch",
      children: [t2, t3]
    });
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}